import { get, writable } from "svelte/store";

let map = new Map();

let _enabled = true;
let enabledStore = writable(_enabled);
enabledStore.subscribe((v) => {
  _enabled = v;
});

export function mount(hotkey, action) {
  const handler = (ev) => {
    hotkey = String(hotkey).toLowerCase();
    const key = String(ev.key).toLowerCase();
    if (
      _enabled &&
      key === hotkey &&
      !ev.metaKey &&
      !ev.ctrlKey &&
      !ev.shiftKey
    ) {
      ev.preventDefault();
      action(ev);
    }
  };
  if (hotkey) {
    if (map.has(hotkey)) {
      console.warn(`Hotkey ${hotkey} exists already, might cause issues`);
    }
    window.addEventListener("keydown", handler, { passive: false });
  }
  return () => {
    if (hotkey) {
      if (map.has(hotkey)) map.delete(hotkey);
      window.removeEventListener("keydown", handler);
    }
  };
}

export function setEnabled(e) {
  enabledStore.update(() => e);
}

export function isEnabled() {
  return _enabled;
}

export function getEnabledStore() {
  return enabledStore;
}
